import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordStrengthMeterComponent } from '@app/shared/ui/simple-components/password-strength-meter/password-strength-meter.component';
import { StepNumberAndCirclesComponent } from '@app/shared/ui/simple-components/step-number-and-circles/step-number-and-circles.component';
import { ProgressBarComponent } from '@app/shared/ui/simple-components/progress-bar/progress-bar.component';
import { FileUploadTagComponent } from '@app/shared/ui/simple-components/file-upload-tag/file-upload-tag.component';
import { ComponentRendererComponent } from './component-renderer/component-renderer.component';
import { SidebarPositionSwitcherComponent } from './sidebar-position-switcher/sidebar-position-switcher.component';
import { TabsToolbarComponent } from './tabs-toolbar/tabs-toolbar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SpinnerModule } from '@app/shared/ui/simple-components/spinner/spinner.module';
import { InfoBlockComponent } from '@app/shared/ui/simple-components/info-block/info-block.component';
import { PagingInputComponent } from './paging-input/paging-input.component';
import { SwithButtonsInputComponent } from './swith-buttons-input/swith-buttons-input.component';
import { ButtonGroupModule, ButtonModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { ToggleButtonsSetComponent } from './toggle-buttons-set/toggle-buttons-set.component';
import { TmfDocumentSelectorComponent } from '@app/shared/ui/simple-components/tmf-document-selector/tmf-document-selector.component';
import { RadioSelectorsComponent } from './radio-selectors/radio-selectors.component';
import { SplitButtonComponent } from './split-button/split-button.component';
import { LinkComponent } from '@app/shared/ui/simple-components/link/link.component';
import { WarningInfoBlockComponent } from './warning-info-block/warning-info-block.component';
import { ViewerHeaderComponent } from './viewer-header/viewer-header.component';
import { CopyLinkComponent } from './copy-link/copy-link.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { StatusComponent } from '@app/shared/ui/simple-components/status/status.component';
import { StatusDropdownComponent } from '@app/shared/ui/simple-components/status-dropdown/status-dropdown.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InformationMessageComponent } from '@app/shared/ui/simple-components/information-message/information-message.component';
import { CompareInfoBlockComponent } from '@app/shared/ui/simple-components/compare-info-block/compare-info-block.component';
import { NumericTextBoxModule } from '@progress/kendo-angular-inputs';

const components = [
  StepNumberAndCirclesComponent,
  PasswordStrengthMeterComponent,
  ProgressBarComponent,
  FileUploadTagComponent,
  ComponentRendererComponent,
  SidebarPositionSwitcherComponent,
  TabsToolbarComponent,
  InfoBlockComponent,
  CompareInfoBlockComponent,
  PagingInputComponent,
  SwithButtonsInputComponent,
  ToggleButtonsSetComponent,
  TmfDocumentSelectorComponent,
  RadioSelectorsComponent,
  SplitButtonComponent,
  LinkComponent,
  WarningInfoBlockComponent,
  ViewerHeaderComponent,
  CopyLinkComponent,
  StatusComponent,
  StatusDropdownComponent,
  InformationMessageComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SpinnerModule,
    ButtonModule,
    ButtonGroupModule,
    DropDownButtonModule,
    PipesModule,
    ClipboardModule,
    TooltipModule,
    DropDownsModule,
    ReactiveFormsModule,
    NumericTextBoxModule,
  ],
  declarations: components,
  exports: [SpinnerModule, ...components],
})
export class SimpleComponentsModule {}
